import Alpine from '../../../../../../../CodeQ.Site/Resources/Private/Fusion/node_modules/alpinejs'

Alpine.data('shortcutCreationForm', (parentNodePath) => ({
    loading: true,
    title: null,
    createdBy: null,
    target: null,
    parentNodePath: parentNodePath,
    uriPathSegment: null,
    uriPathSegmentIsValid: true,
    suggestedUriPathSegment: '',
    createdByStorageKey: 'neosShortcutCreationForm__createdBy',
    debounceTimer: null,
    uriPathSegmentCheckSequence: 0,

    init () {
        this.$nextTick(async () => {
            if (this.uriPathSegment) {
                await this.validateUriPathSegment(this.uriPathSegment);
            }

            this.loadCreatedByFromStorage();

            // Watch for changes specifically on the 'createdBy' field
            this.$watch('createdBy', (newValue) => {
                this.debouncedSaveCreatedBy(newValue);
            });

            this.loading = false;
        })
    },

    uriPathSegmentInput: {
        async ['@input.debounce'](e) {
            if (!e.target.value) {
                this.uriPathSegmentIsValid = true;
                return
            }
            await this.validateUriPathSegment(e.target.value);
        }
    },

    // Fails open on network errors so `loading` can never get stuck and lock the
    // submit button — the server re-validates the path segment on submit anyway.
    // The sequence counter discards out-of-order responses while typing.
    async validateUriPathSegment (text) {
        const sequence = ++this.uriPathSegmentCheckSequence;
        this.loading = true;
        try {
            const foreignUriPathSegment = await this.checkUriPathSegment(text);
            if (sequence !== this.uriPathSegmentCheckSequence) {
                return;
            }
            if (this.uriPathSegment === foreignUriPathSegment) {
                this.uriPathSegmentIsValid = true;
            } else {
                this.uriPathSegmentIsValid = false;
                this.suggestedUriPathSegment = foreignUriPathSegment;
            }
        } catch (error) {
            console.warn('Could not validate the uri path segment.', error);
            if (sequence === this.uriPathSegmentCheckSequence) {
                this.uriPathSegmentIsValid = true;
            }
        } finally {
            if (sequence === this.uriPathSegmentCheckSequence) {
                this.loading = false;
            }
        }
    },

    async checkUriPathSegment (text) {
        const response = await fetch(`/codeq/shortcuts/validateuripathsegment.json?parentNode=${encodeURIComponent(this.parentNodePath)}&text=${encodeURIComponent(text)}`)
        if (!response.ok) {
            throw new Error(`Unexpected response status ${response.status}`);
        }
        const jsonData = await response.json();
        if (typeof jsonData.uriPathSegment !== 'string') {
            throw new Error('Response did not contain a uriPathSegment');
        }
        return jsonData.uriPathSegment;
    },

    applySuggestedUriPathSegment () {
        this.uriPathSegment = this.suggestedUriPathSegment
        this.uriPathSegmentIsValid = true
    },

    isValidTargetUrl (value) {
        if (!value) {
            return false;
        }
        try {
            const url = new URL(value.trim());
            return url.protocol === 'https:' && url.hostname.includes('.');
        } catch (error) {
            return false;
        }
    },

    get targetIsInvalid () {
        return Boolean(this.target) && !this.isValidTargetUrl(this.target)
    },

    get canSubmit () {
        return !this.loading && Boolean(this.title) && Boolean(this.createdBy) && this.uriPathSegmentIsValid && this.isValidTargetUrl(this.target)
    },

    // Loads the 'createdBy' value from localStorage, handling potential errors
    loadCreatedByFromStorage() {
        try {
            const storedValue = localStorage.getItem(this.createdByStorageKey);
            if (storedValue) {
                this.createdBy = storedValue;
            }
        } catch (e) {
            console.warn('Browser storage is not available. Could not load user name.', e);
        }
    },

    // Saves the 'createdBy' value to localStorage, handling potential errors
    saveCreatedByToStorage(value) {
        try {
            localStorage.setItem(this.createdByStorageKey, value);
        } catch (e) {
            console.warn('Could not save user name to browser storage.', e);
        }
    },

    // Debounce mechanism to avoid saving on every keystroke
    debouncedSaveCreatedBy(value) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
            this.saveCreatedByToStorage(value);
        }, 500); // 500ms delay
    },
}));
